import { render, staticRenderFns } from "./AppExpansionPanel.vue?vue&type=template&id=3c71dc8c&scoped=true&"
import script from "./AppExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./AppExpansionPanel.vue?vue&type=script&lang=js&"
import style0 from "./AppExpansionPanel.vue?vue&type=style&index=0&id=3c71dc8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c71dc8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VIcon})
